import { useCallback } from 'react';

// Google OAuth 2.0 Authorization Code flow — direct integration, no third-party SDK.
// Backend endpoint exchanges the code and redirects to /auth-redirect with JWT.
const GOOGLE_CLIENT_ID = '378059575152-ho3rbueni7rpv73l1neh69m8cbmmhb9d.apps.googleusercontent.com';
const GOOGLE_REDIRECT_URI = 'https://api.flymind.travel/api/auth/google/callback';

// Apple Sign In — same pattern, uses response_mode=form_post
const APPLE_CLIENT_ID = 'com.travel.flymind';
const APPLE_REDIRECT_URI = 'https://api.flymind.travel/api/auth/apple/callback';

function buildGoogleAuthUrl(): string {
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: GOOGLE_REDIRECT_URI,
    response_type: 'code',
    scope: 'openid email profile',
    access_type: 'online',
    prompt: 'select_account',
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}

function buildAppleAuthUrl(): string {
  const params = new URLSearchParams({
    client_id: APPLE_CLIENT_ID,
    redirect_uri: APPLE_REDIRECT_URI,
    response_type: 'code',
    scope: 'name email',
    response_mode: 'form_post', // Required by Apple when scope includes name/email
  });
  return `https://appleid.apple.com/auth/authorize?${params.toString()}`;
}

export function useSocialAuth() {
  const signInWithGoogle = useCallback(() => {
    window.location.href = buildGoogleAuthUrl();
  }, []);

  const signInWithApple = useCallback(() => {
    window.location.href = buildAppleAuthUrl();
  }, []);

  return { signInWithGoogle, signInWithApple };
}
